import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AbousUs";
import Projects from "./pages/Projects";
import PaymentPlan from "./pages/PaymentPlan";
import Navbar from "./components/Layout/Navbar";
import Footer from "./components/Layout/Footer";
import Contact from "./pages/Contact";
import HoveringButtons from "./components/Layout/HoveringButtons";
import Gallery from "./pages/Gallery";
import PearlResidencia from "./pages/PearlResidencia";
import ResetToTop from "./hooks/resetToTop";

function App() {
    return (
        <Router>
            <Navbar />
            <HoveringButtons />
            <ResetToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/payment-plans" element={<PaymentPlan />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/pearl-residencia" element={<PearlResidencia />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
